export default ['popupData', function (popupData) {
  if (popupData) {
    this.message =  popupData.message;
  }
}];
